import { actions, action } from './actions';
import { getters, reportDetailComputed } from './getters';
import { mutations, mutation } from './mutations';
import { state } from './state';

/**
 * @type {import('vuex').Module<ReportDetailState>}
 */
export const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export { action, mutation, reportDetailComputed };

/**
 * @typedef {import('./state').ReportDetailState} ReportDetailState
 */
